import { createFileRoute, useMatchRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import {
  ClauseResponse,
  endpointClauseGET,
} from '~/api/def/endpoints/clauseEndpoint';
import { ClauseLayout } from '~/components/pages/clause/Clause';

export const Route = createFileRoute(
  '/_authLayout/obligations/clause/$documentId/$clauseId',
)({
  component: ObligationsClauseComponent,
});

function ObligationsClauseComponent() {
  const match = useMatchRoute();
  const clauseIdMatch = match({
    to: '/obligations/clause/$documentId/$clauseId',
  });
  const clauseId = clauseIdMatch ? clauseIdMatch.clauseId : false;
  const documentId = clauseIdMatch ? clauseIdMatch.documentId : false;
  const [clauseResponse, setClauseResponse] = useState<ClauseResponse | null>(
    null,
  );
  useEffect(() => {
    if (clauseId && documentId) {
      endpointClauseGET(`/${documentId}/${clauseId}`).then((res) => {
        if (res) {
          setClauseResponse(res);
        }
      });
    }
  }, [clauseId, documentId]);
  return (
    <div>
      <h3>Obligations Clause</h3>

      {clauseResponse && (
        <ClauseLayout
          clause={clauseResponse.clause}
          document={clauseResponse.doc}
          fullText={clauseResponse.fullText}
        />
      )}
    </div>
  );
}
